import { useErrorStore } from "@/stores/ErrorStore";
import { usePaidEarnedMediaStore } from "@/stores/PaidEarnedMediaStore";

export const PaidEarnedMediaStores = [useErrorStore, usePaidEarnedMediaStore];

export const PaidEarnedMediaChannel = {
  received(payload) {
    if (payload.status === "error" || payload.data?.status === "error") {
      const task = Object.keys(this.paidEarnedMediaStore.taskIds).find(
        (task) => this.paidEarnedMediaStore.taskIds[task] === payload.id,
      );
      if (task) {
        this.paidEarnedMediaStore.taskIds[task] = undefined;
        if (task === "toplineNumbersData") {
          this.paidEarnedMediaStore.loading.topline_numbers = {
            table: false,
            charts: false,
          };
          this.paidEarnedMediaStore.errors.toplineNumbersData = payload.message;
        } else if (task === "creativesAtAGlanceData") {
          this.paidEarnedMediaStore.loading.creatives_at_a_glance = false;
          this.paidEarnedMediaStore.errors.creativesAtAGlanceData =
            payload.message;
        } else if (task === "dateTrackerData") {
          this.paidEarnedMediaStore.loading.date_tracker = false;
          this.paidEarnedMediaStore.errors.dateTrackerData = payload.message;
        } else {
          if (
            task === "sponsors" &&
            payload.id ===
              this.paidEarnedMediaStore.taskIds.sponsorsForCreativesTab
          ) {
            this.paidEarnedMediaStore.loading.sponsorsForCreativesTab = false;
          }
          this.paidEarnedMediaStore.loading[task] = false;
          this.errorStore.showError(payload.message);
        }
      }
    }
    if (payload.id === this.paidEarnedMediaStore.taskIds.dates) {
      this.paidEarnedMediaStore.dates = payload.data.dates;
      this.paidEarnedMediaStore.taskIds.dates = undefined;
      this.paidEarnedMediaStore.loading.dates = false;
    }
    if (payload.id === this.paidEarnedMediaStore.taskIds.races) {
      this.paidEarnedMediaStore.races = payload.data;
      this.paidEarnedMediaStore.taskIds.races = undefined;
      this.paidEarnedMediaStore.loading.races = false;
    }
    if (payload.id === this.paidEarnedMediaStore.taskIds.sponsors) {
      this.paidEarnedMediaStore.sponsors = payload.data;
      if (!this.paidEarnedMediaStore.sponsorsForCreativesTab.length) {
        this.paidEarnedMediaStore.sponsorsForCreativesTab = payload.data;
        this.paidEarnedMediaStore.loading.sponsorsForCreativesTab = false;
      }
      this.paidEarnedMediaStore.taskIds.sponsors = undefined;
      this.paidEarnedMediaStore.loading.sponsors = false;
    }
    if (
      payload.id === this.paidEarnedMediaStore.taskIds.sponsorsForCreativesTab
    ) {
      this.paidEarnedMediaStore.sponsorsForCreativesTab = payload.data;
      this.paidEarnedMediaStore.taskIds.sponsorsForCreativesTab = undefined;
      this.paidEarnedMediaStore.loading.sponsorsForCreativesTab = false;
    }
    if (payload.id === this.paidEarnedMediaStore.taskIds.projectRaces) {
      this.paidEarnedMediaStore.projectRaces = payload.data;
      this.paidEarnedMediaStore.taskIds.projectRaces = undefined;
      this.paidEarnedMediaStore.loading.projectRaces = false;
    }
    if (payload.id === this.paidEarnedMediaStore.taskIds.projectSponsors) {
      this.paidEarnedMediaStore.projectSponsors = payload.data;
      this.paidEarnedMediaStore.taskIds.projectSponsors = undefined;
      this.paidEarnedMediaStore.loading.projectSponsors = false;
    }
    if (
      payload.id === this.paidEarnedMediaStore.taskIds.toplineNumbersData &&
      (this.paidEarnedMediaStore.loading.topline_numbers.table ||
        this.paidEarnedMediaStore.loading.topline_numbers.charts)
    ) {
      this.paidEarnedMediaStore.taskIds.toplineNumbersData = undefined;
      this.paidEarnedMediaStore.loading.topline_numbers.table = false;
      this.paidEarnedMediaStore.loading.topline_numbers.charts = false;
      this.paidEarnedMediaStore.toplineNumbers = payload.data;
      this.paidEarnedMediaStore.appliedFilters = {
        ...this.paidEarnedMediaStore.filters,
      };
      this.paidEarnedMediaStore.appliedCreativesSideFilters = {
        ...this.paidEarnedMediaStore.creativesSideFilters,
      };
    }
    if (
      payload.id === this.paidEarnedMediaStore.taskIds.creativesAtAGlanceData &&
      this.paidEarnedMediaStore.loading.creatives_at_a_glance
    ) {
      this.paidEarnedMediaStore.taskIds.creativesAtAGlanceData = undefined;
      this.paidEarnedMediaStore.loading.creatives_at_a_glance = false;
      this.paidEarnedMediaStore.creativesAtAGlance = payload.data?.results;
      this.paidEarnedMediaStore.appliedFilters = {
        ...this.paidEarnedMediaStore.filters,
      };
      this.paidEarnedMediaStore.appliedCreativesSideFilters = {
        ...this.paidEarnedMediaStore.creativesSideFilters,
      };
    }
    if (
      payload.id === this.paidEarnedMediaStore.taskIds.dateTrackerData &&
      this.paidEarnedMediaStore.loading.date_tracker
    ) {
      this.paidEarnedMediaStore.taskIds.dateTrackerData = undefined;
      this.paidEarnedMediaStore.loading.date_tracker = false;
      this.paidEarnedMediaStore.dateTracker = payload.data;
      this.paidEarnedMediaStore.appliedFilters = {
        ...this.paidEarnedMediaStore.filters,
      };
      this.paidEarnedMediaStore.appliedCreativesSideFilters = {
        ...this.paidEarnedMediaStore.creativesSideFilters,
      };
    }
  },
};
